
        <i *ngIf="iconClass" [ngClass]="classMap" theme="contained"></i>
    